import { HeaderRow, LoaderOverlay } from "@emanprague/ppaskit";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import GeneralSettingCard from "components/GeneralSettingCard";
import DisabledLoginCard from "components/DisabledLoginCard";
import { observer } from "mobx-react-lite";
import React from "react";
import GeneralSettingsPageViewModel from "viewModels/admin/generalSettingsPageViewModel";
import "./style.scss";
import googleLogo from "../../components/OmniAuthButton/google.svg";
import seznamLogo from "../../components/OmniAuthButton/seznam.svg";
import bankIdLogo from "../../components/BankIdButton/bankidLogoSmall.svg";
import ProviderSettingCard from "components/ProviderSettingCard";

const generalSettingsPageView: ViewComponent<GeneralSettingsPageViewModel> = observer(({ vm }) => {
  const loginDisabled = vm.loginDisabledSetting?.active;

  const toggleLoginCard = (state?: boolean) => {
    if (state == undefined) {
      return;
    }

    const text = state ? vm.translate("login_disabled") : vm.translate("login_enabled");
    const buttonText = state ? vm.translateGeneral("enable") : vm.translateGeneral("disable");
    const style = state ? "text-danger" : "text-success";
    const buttonType = state ? "success" : "danger";

    return (
      <GeneralSettingCard>
        <h1 className={style} style={{ marginBottom: "unset", fontSize: "1.5rem", fontWeight: "bold", lineHeight: "1.5" }}>
          {text}
        </h1>
        <button className={`btn btn-${buttonType}`} onClick={vm.toggleLoginSetting}>
          {buttonText}
        </button>
      </GeneralSettingCard>
    );
  };

  return (
    <>
      <HeaderRow level={1} title={vm.name} className="mx-1 mx-sm-n3" />
      <LoaderOverlay loading={vm.busyWatcher.isBusy}>
        <GeneralSettingCard>
          {vm.lastUpdatedAtText()}
          <button className="btn btn-primary" onClick={vm.refreshEnumerations}>
            {vm.translate("refresh_enums")}
          </button>
        </GeneralSettingCard>
        {toggleLoginCard(loginDisabled)}

        <ProviderSettingCard
          translate={vm.translate}
          translateGeneral={vm.translateGeneral}
          updateSettings={vm.updateProviderSettings}
          loginSettings={[
            {
              name: "Google",
              icon: googleLogo,
              setting: vm.googleLoginSetting!,
              description: vm.translate("providers_setting.for_login_and_registration"),
            },
            {
              name: "Seznam",
              icon: seznamLogo,
              setting: vm.seznamLoginSetting!,
              description: vm.translate("providers_setting.for_login_and_registration"),
            },
            {
              name: "BankID",
              icon: bankIdLogo,
              description: vm.translate("providers_setting.for_registration_only"),
            },
          ]}
        />

        {vm.loginDisabledSetting && (
          <DisabledLoginCard
            disabledLoginSetting={vm.loginDisabledSetting}
            onSubmit={vm.updateDisabledLoginContent}
            onFillDefault={vm.fillDefaultDisabledLoginContent}
            translateGeneral={vm.translateGeneral}
            translate={vm.translate}
          />
        )}
      </LoaderOverlay>
    </>
  );
});

registerView(generalSettingsPageView, GeneralSettingsPageViewModel);

export default generalSettingsPageView;
